/** @format */

import { ProductPrice } from './product-price.interface';
import { SkuPriceCollectionName } from '@shared/data-access/enums';
import { BucketedDefiningAttribute } from './bucketed-defining-attribute.interface';

export interface SkuAttribute {
  bucket: SkuAttributeBucket;
  bucketColors?: string[];
  muted?: boolean;
  name: SkuPriceCollectionName;
  productPrice: ProductPrice;
  productPriceRange?: ProductPrice;
  selections?: any;
}

export interface SkuAttributeBucket {
  defAttributes: BucketedDefiningAttribute;
}
